<template lang="pug">
  .postpone-subscription-modal.clearfix
    .xs-12.text-center
      p.upper.bold.xs-f-small.lg-f-medium.max-at-tweak(data-mr-ass="postpone-modal") Postpone next shipment
    
    form.postpone-subscription-form.xs-12(@submit.prevent="postponeSubscription()")
      .when-wrap.xs-12
        legend.xs-f-small.lg-f-medium.max-at-tweak.text-center When would you like us to ship your next box?

      .xs-12
        NextDateSelector.xs-12(:subId="subInEdit.id", :nextDate="postponeDate" @onDateSelect="setPostponeDate" data-mr-ass="next-date-selector")

      .submit-cancel-wrap.xs-12.text-center
        button.mr-btn.btn-fixed-width.xs-f-xsmall.max-at-tweak(type="submit" :class="{ disabled: savingSub }" data-mr-ass="postpone-sub-button") Postpone
        button.cancel.text-center.xs-f-small.max-at-tweak(type="button" @click="cancel") Cancel
  
</template>

<script>
  import { mapState, mapMutations, mapActions } from 'vuex';
  import vueSubscriptionSvc from '../../../services/vueSubscriptionSvc';
  import mrRadio from '../../mrRadio';
  import NextDateSelector from "./NextDateSelector";

  export default {
    name: 'PostponeSubscriptionModal',

    data() {
      return {
        postponeDate: null,
        invalidNextDates: []
      }
    },

    components: {
      NextDateSelector,
      mrRadio
    },

    asyncComputed: {
      dateOptions() {
        return vueSubscriptionSvc.getSubDateOptions({
          sub_id: this.subInEdit.id
        }).then(res => res.data);
      }
    },

    computed: {
      ...mapState('subscriptions', [
        'savingSub',
        'subInEdit'
      ]),
      
      minPostponeDate() {
        return new Date();
      },

      maxPostponeDate() {
        if (!this.dateOptions || !this.dateOptions.maxSkipDays) {
          return null;
        }
        return new Date(new Date().setDate(this.minPostponeDate.getDate() + (this.dateOptions.maxSkipDays - 1)));
      }
    },

    methods: {
      ...mapMutations('subscriptions', [
        'clearSubInEdit'
      ]),

      ...mapActions('subscriptions', [
        'updateSubscription'
      ]),

      ...mapActions('modal', ['hideModal']),

      setPostponeDate(date) {
        this.postponeDate = date;
      },

      postponeSubscription() {
        this.updateSubscription({
          sub_id: this.subInEdit.id,
          changes: {
            next: this.postponeDate.substring(0, 10)
          }
        }).then(() => {
          this.clearSubInEdit();
          this.hideModal();
        });
      },

      cancel() {
        this.clearSubInEdit();
        this.hideModal();
      }
    },

    created() {
      this.postponeDate = this.subInEdit.next;
    }
  }
</script>

<style lang="stylus">
  .postpone-subscription-modal
    max-width 30em
    margin 0 auto
    
    .when-wrap
      padding-top 1.5em
      padding-left 5%
      padding-right 5%
      
      legend
        margin-bottom 1em
      
    .postpone-radio
      display block
      padding 0.75em 0
      
    .submit-cancel-wrap
      padding 1em 0
      
      .cancel
        display block
        border none
        background transparent
        width 100%
        padding 0.5em
        margin-top 0.5em
    
    @media mq-tablet
      max-width 36em
      
    @media mq-desktop-md
      max-width 36em
      
    @media mq-desktop-plus
      max-width 36em
      
</style>
